import { useEffect, useState } from 'react'
import { Select, Row, Col, Space } from 'antd'
import { baseAxiosNoInfo } from '../../tool/axios'

const { Option } = Select

interface SelectAreaProp {
    value?: {
        province_code: string,
        city_code: string,
        area_code: string
    },
    onChange?: (v: { province_code: string, city_code: string, area_code: string }) => void
}

// 省市区
export function SelectArea(props: SelectAreaProp) {

    const [provinceCode, setProvinceCode] = useState<string>('')
    const [cityCode, setCityCode] = useState<string>('')
    const [areaCode, setAreaCode] = useState<string>('')

    const [provinces, setProvince] = useState<{ province_code: string, province_name: string }[]>([])
    const [citys, setCitys] = useState<{ city_code: string, city_name: string }[]>([])
    const [areas, setAreas] = useState<{ area_code: string, area_name: string }[]>([])

    const onProvinceChange = (val: string) => {
        setProvinceCode(val)
        baseAxiosNoInfo('/global/city_list', {
            params: {
                province_code: val
            }
        }).then((res: any) => {
            if (res) {
                setCitys(res)

                if (props.value?.city_code) {
                    setCityCode(props.value?.city_code)
                    onCityChange(props.value?.city_code)
                }
            }
        })
    }

    const onCityChange = (val: string) => {
        setCityCode(val)
        baseAxiosNoInfo('/global/area_list', {
            params: {
                city_code: val
            }
        }).then((res: any) => {
            if (res) {
                setAreas(res)

                if (props.value?.area_code) {
                    setAreaCode(props.value?.area_code)
                }
            }
        })
    }

    const onAreaChange = (val: string) => {
        setAreaCode(val)
        if (props.onChange) {
            props.onChange({ province_code: provinceCode, city_code: cityCode, area_code: val })
        }
    }

    useEffect(() => {
        baseAxiosNoInfo('/global/province_list').then((res: any) => {
            if (res) {
                setProvince(res)
            }
        })
    }, [])

    useEffect(() => {
        if (props.value) {
            if (props.value && provinces.length > 0) {
                onProvinceChange(props.value.province_code)
            }
        }
    }, [provinces, props.value])

    return (<Row gutter={16}>
        <Col span={6}>
            <Select onChange={onProvinceChange} value={provinceCode}>
                {provinces.map((el: { province_code: string, province_name: string }) => <Option key={el.province_code} value={el.province_code}>{el.province_name}</Option>)}
            </Select>
        </Col>

        <Col span={6}>
            <Select onChange={onCityChange} value={cityCode}>
                {citys.map((el: { city_code: string, city_name: string }) => <Option key={el.city_code} value={el.city_code}>{el.city_name}</Option>)}
            </Select>
        </Col>

        <Col span={6}>
            <Select onChange={onAreaChange} value={areaCode}>
                {areas.map((el: { area_code: string, area_name: string }) => <Option key={el.area_code} value={el.area_code}>{el.area_name}</Option>)}
            </Select>
        </Col>
    </Row>)
}

interface SelectProductTypeProp {
    disabled?: boolean,
    value?: string,
    onChange?: (v: any) => void
}

// 商品分类
export function SelectProductType(props: SelectProductTypeProp) {

    const [optionData, setOptionData] = useState<{}[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/global/goods_type_list').then((res: any) => {
            if (res) setOptionData(res)
        })
    }, [])

    let Options = optionData.map((el: any) => (<Option value={el.id} key={el.id}>{el.goods_type_name}</Option>))

    return (
        <Select
            disabled={props.disabled}
            allowClear
            style={{ width: 120 }}
            placeholder="商品分类"
            onChange={props.onChange}
            value={props.value}
        >
            {Options}
        </Select>)
}

interface SelectGoodsByTypeProp {
    sceneType: number
    goodsChange?: (v: string) => void
    disabled?: boolean
    showSearch?: boolean
    value?: { goodsID: string, typeID: string }
    onChange?: (v: any) => void
}

// 商品分类和商品
export function SelectGoodsByType(props: SelectGoodsByTypeProp) {

    const [optionData, setOptionData] = useState<{}[]>([])
    const [typeID, setTypeID] = useState<string>('')
    const [goodsID, setGoodsID] = useState<string>('')

    const handleTypeChange = (v: string) => {
        setTypeID(v)
        setGoodsID('')
    }

    const handleGoodsChange = (v: string) => {
        if (props.onChange) props.onChange({ goodsID: v, typeID })
        if (props.goodsChange) props?.goodsChange(v)
    }

    let Options = optionData.map((el: any) => (<Option value={el.id} key={el.id}>{el.goods_name}</Option>))

    useEffect(() => {
        if (typeID) {
            baseAxiosNoInfo('/global/goods/spu_list', { params: { goods_type_id: typeID, scene_type: props.sceneType } }).then((res: any) => {
                if (res) setOptionData(res)
            })
        }
    }, [typeID])

    useEffect(() => {
        if (props.value) {
            setTypeID(props.value.typeID)
            setGoodsID(props.value.goodsID)
        }
    }, [props.value])

    return <Space direction="horizontal" wrap>
        <SelectProductType disabled={props.disabled} value={typeID} onChange={handleTypeChange} />

        <Select
            showSearch
            allowClear
            virtual={false}
            disabled={props.disabled}
            onChange={handleGoodsChange}
            style={{ width: 220 }}
            value={goodsID}
            filterOption={props.showSearch ? (input, option) => (option!.children as unknown as string).includes(input) : false}
        >
            {Options}
        </Select>
    </Space>
}


interface SelecSupplierProp {
    value?: string,
    onChange?: (v: any) => void
}

// 供应商
export function SelecSupplier(props: SelecSupplierProp) {

    const [optionData, setOptionData] = useState<{}[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/global/supply/list').then((res: any) => {
            if (res) setOptionData(res)
        })
    }, [])

    let Options = optionData.map((el: any) => (<Option value={el.id} key={el.id}>{el.supply_name}</Option>))

    return (
        <Select style={{ width: 200 }} placeholder="供应商" onChange={props.onChange} value={props.value} >
            {Options}
        </Select>)
}